import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { SortItem } from '../../../models/sort-item.model';

@Component({
  selector: 'sort',
  templateUrl: './sort.component.html',
  styleUrls: ['./sort.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})

//! NOTE - the "1" is tmp, should be the product group ID
// "1" is the default for eComm
export class SortComponent implements OnInit {
  @Output() update = new EventEmitter<SortItem[]>();

  public selectedSort: SortItem;
  public sortActive = false;

  @Input() mobile = false;
  @Input() position = '';

  _sorts: SortItem[] = [];
  @Input() set sorts(val: SortItem[]) {
    if (val && val.length > 0) {
      this._sorts = val;
      this.findSelectedSort();
    }
  }

  constructor(private hostElement: ElementRef) {}

  ngOnInit() {}

  private findSelectedSort() {
    if (this._sorts) {
      this.selectedSort = this._sorts.find((item) => {
        return item.selected === true;
      });
      if (!this.selectedSort) {
        this._sorts[0].selected = true;
        this.selectedSort = this._sorts[0];
        this.updateSort(this.selectedSort);
      }
    }
  }

  updateSort(sortItem) {
    this._sorts.map((item) => {
      item.selected = false;
    });
    sortItem.selected = true;
    this.update.emit(this._sorts);

    this.selectedSort = sortItem;
    this.sortActive = false;
  }

  toggleSort() {
    this.sortActive = !this.sortActive;
  }

  @HostListener('document:click', ['$event'])
  clickedOutside($event) {
    if (
      this.sortActive &&
      $event.target != this.hostElement.nativeElement &&
      this.hostElement.nativeElement.contains($event.target) === false
    ) {
      this.sortActive = false;
    }
  }

  get hasDirection(): boolean {
    return this.selectedSort && !!this.selectedSort.direction;
  }

  toggleDirection() {
    this.selectedSort.toggleDirection();
    this.updateSort(this.selectedSort);
  }

  get sortDirectionClass(): string {
    if (!this.hasDirection) {
      return '';
    }

    let sortDirection = this.selectedSort.direction === 'ASC' ? 'up' : 'down';
    let sortType = 'amount';
    if (this.selectedSort.directionType === 'alpha') {
      sortDirection = this.selectedSort.direction === 'ASC' ? 'down' : 'up'; // for alpha sorting direction is opposite
      sortType = 'alpha';
    }

    return `fa-sort-${sortType}-${sortDirection}`;
  }
}

// TODO make sure all elements have line separator
